// components/ViewAllImagesModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaEye, FaTrash } from 'react-icons/fa';
import './view-all-images-modal.css';

const ViewAllImagesModal = ({ show, onClose, documents = [], onDelete  }) => {
  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Uploaded Images</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {documents.length === 0 ? (
          <p>No images uploaded.</p>
        ) : (
          <ul className="list-group">
            {documents.map((doc, index) => (
              <li
                key={index}
                className="list-group-item d-flex justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center gap-2">
                  {/* Thumbnail preview */}
                  <a
  href={doc.path}
  target="_blank"
  rel="noopener noreferrer"
>
                  <img
                    src={doc.path}
                    // alt={doc.name}
                    style={{
                      width: '40px',
                      height: '40px',
                      objectFit: 'cover',
                      borderRadius: '4px',
                      cursor: 'pointer',
                    }}
                  />
                  </a>
                  {/* <span className="file-name-text">{doc.name}</span> */}
                  {doc.name}
                    </div>
                      {/* Buttons */}
                <div className="d-flex gap-2">
                  {/* View */}
                  <a
                    href={doc.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    <FaEye /> View
                  </a>

                  {/* Title button */}
                  <Button
                    size="sm"
                    variant="outline-success"
                    onClick={() => alert(`Add title for ${doc.name}`)}
                  >
                    Title
                  </Button>

                  {/* Description button */}
                  <Button
                    size="sm"
                    variant="outline-info"
                    onClick={() => alert(`Add description for ${doc.name}`)}
                  >
                    Description
                  </Button>

                  {/* Delete */}
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={() => onDelete && onDelete(index)}
                  >
                    <FaTrash /> Delete
                  </Button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button className="btn btn-md-imp btn-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewAllImagesModal;
